<div class="add-70">
    <div class="small-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
                <h2 class="font-600 text-center">
                    Privacy Policy
                </h2>
        </div>
    </div>
</div>

<div class="page-section">
    <div class="container">
        <div class="row">
            <div class="col-12 main-container">
                <h3 class="text-center">NuvertOS Privacy Policy</h3>
                <div style="display: grid">
                    <div class="divider"></div>
                </div>
                <p>
                    NuvertOS (hereinafter referred to as “we” or “us”) through its website or mobile application owned and operated through M/s TIMESTREAM TECHNOLOGIES PRIVATE LIMITED strives to bring the best possible services to you (the user) and makes continual efforts for the same. NuvertOS expressly undertakes to value user privacy (hereinafter referred to as “you” or “your”) and recognizes the need to protect any personal identifiable information (any information by which you can be identified, such as name, address and telephone number) you share with us. We would like to assure you that we follow appropriate standards when it comes to protecting your privacy on our sites.
<br><br>
We at NuvertOS are committed to maintain the privacy of personal information that comes to our knowledge as a result of your use and access to the NuvertOS Platform. This Privacy Policy describes how we treat personal information received about you when you visit “our” platform and is for the purpose of making you aware of your legal obligations and rights in pursuance of your access to the Platform.
<br><br>

We may take content or services from other web sites including our co-branded web sites available to you from links located on our site. However, such other websites are not subject to our Privacy Policy. We strongly recommend you to read and carefully review the privacy policy at each such web site to determine how that site protects your privacy.
<br><br>

Further, by accessing or using our Platform, you agree that you have read, understood and agree to our collection, storage, use and disclosure of your personal information as described in this Privacy Policy and our Terms of Use.
<br><br>

1. USER INFORMATION COLLECTED
<br><br>

1.1. Data Provided by the
<br><br>

1.1.1. Contact and profile information
In pursuance of user account registration on NuvertOS, we may collect certain personal information including but not limited to name, phone number, e-mail address, physical address and social media account information where any information accesses NuvertOS through any SNS (Social Networking services). We may use this information for the limited purpose of
<br><br>


1.1.1.1. Creating and personalizing your Account;
<br><br>

1.1.1.2. Communicating with you directly about the Services as well as about any questions, issues or concerns you or other users may have,
<br><br>

1.1.1.3. Fulfilling your services, and
<br><br>

1.1.1.4. Sending marketing communications in accordance with user preferences.
<br><br>

1.1.1.5. Sending your emails or SMS about your services or enquiring about feedback.
<br><br>

1.1.1.6. Rendering you with a personal experience
<br><br>

1.1.1.7. Improving website
<br><br>

1.1.1.8. Providing additional services available on NuvertOS.
<br><br>

1.2. Sensitive Personal Information
<br><br>

Sensitive Personal Identifying Information (PII) is defined as information that if lost, compromised, or disclosed could result in substantial harm, embarrassment, inconvenience, or unfairness to an individual.
<br><br>

Sensitive personal information includes:
<br><br>

1. Bank account information
<br><br>

2. Passport information
<br><br>

3. Healthcare related information
<br><br>

4. Medical insurance information
<br><br>

5. Credit card/ debit card numbers
In such case where user(s) agreed that the information provided by them to use our services has given their full consent then such users shall not hold NuvertOS liable under any existing laws.
<br><br>

1.3. Communications, Participation and other Content
<br><br>

We may further undertake and maintain communication with you as a result of your interaction or availing any of our services by email, phone, mail or chat and further may access your location through modern technological means like geo-location, geo-fencing and OTP push-up notifications for better provision of the agreed services, and may further undertake to record comments and opinions you express and further in the due course of addressing any of your queries, questions, issues and concerns and provide other related Client support services, for safety and security purposes, to improve our Services, and for analytics. We may also enable such functionality to maintain ratings and reviews regarding NuvertOS.
<br><br>

1.4. Information Collected or Generated through use of NuvertOS
<br><br>

1.4.1. Information about your device and its software
<br><br>

We may also record certain information that is auto-generated due to the reason of the use of NuvertOS Platform by you containing the information regarding your device including but not limited to IP address, browser type, internet service provider, device, type/model/manufacturer, operating system, date and time stamp, and a unique ID for the further purpose of enabling identification of browser, mobile device, or user Account and other similar information. We expressly provide that such use shall be used to diagnose and fix technology problems, serve you personalized advertising, personalize your experience, perform analytics/identify usage trends, and improve our products and Services.
<br><br>

1.4.2. Information About the manner of NuvertOS Access
<br><br>

NuvertOS expressly provides that it may keep a track on the pages visited by you, including the links clicked on the Platform, whether by reason of you opening emails or click the links contained in emails sent by us, or due to any other actions performed by you while accessing NuvertOS site. We may also use the information about the way you access and use our Services to determine products and services, that may be of interest to you, to improve NuvertOS services to evaluate the success of our advertising and marketing campaigns, and to send you marketing communications.
<br><br>

1.4.3. Analytics information
<br><br>

NuvertOS may also undertake to collect analytics data or use third-party analytics tools such as but not limited to Google Analytics for the purpose of measuring traffic and usage trends and the demographics in the due process of improving our Services.
1.4.4. We typically collect the foregoing generated and/or automatically collected information through a variety of tracking technologies including but not limited to cookies, flash objects, web beacons, embedded scripts, location-identifying technologies, and similar technology but not limited to any third-party partners or services to assist with this effort.
<br><br>
1.5. Images and Videos
<br><br>

With your consent, we may collect images and videos based on the content you submit through the application. These images and videos are stored securely against your user account and are used exclusively for app functionality. We do not share this content with any third parties. The collected media is only utilized to enhance your experience and ensure the proper functioning of the services provided by the application
<br><br>

2. LIMITED USAGE OF PERSONAL INFORMATION
<br><br>

NuvertOS expressly undertakes to use the information provided by you in following manner-
<br><br>

2.1. To provide, maintain, improve and develop the Platform and Services.
<br><br>

2.2. To fulfill your requests and process payments on request of the user;
<br><br>

2.3. To provide custom, personalized content and information
<br><br>

2.4. To perform analytics, detect activity patterns on our Platform and Services, and otherwise research usage, and
<br><br>

2.5. To test and develop new features and functionality and otherwise enhance the Platform and Services.
<br><br>

2.6. To maintain the safety, stability and security of our Platform and Services.
<br><br>

2.7. To communicate important messages to you and/or to provide you with support or to resolve any grievance or query.
<br><br>

2.8. In connection with legal and regulatory proceedings and requirements in pursuance of any governmental inspection or inquiry or any information requested by the former.
<br><br>

2.9. For such specific purpose/s not contemplated by its privacy policy and in such event, we will disclose the same at our end.
<br><br>

3. THIRD PARTY LINKS & DISCLOSURES
<br><br>

3.1. Your personal information may be shared and/or disclosed to following types of third parties:
<br><br>

3.1.1. To Cloud-Server providers
<br><br>

3.1.2. Marketing, research and analysis and communications agencies;
<br><br>

3.1.3. Any third party to whom we assign or novate any of our rights or obligations;
<br><br>

3.1.4. As and when required or authorised by applicable law, and to comply with our legal obligations;
<br><br>

3.1.5 Government agencies and public authorities to comply with a valid and authorised request, including a court order or other valid legal process;
<br><br>

3.1.6. Various regulatory bodies and law enforcement officials and agencies, including to protect against fraud and for related security purposes; and
<br><br>

3.1.7. Enforcement agencies where we suspect that unlawful activity has been or may be engaged in and the personal information is a necessary part of our investigation or reporting of the matter.
<br><br>

3.1.8. Other than the above, we will not disclose your personal information without your consent unless we reasonably believe that disclosure is necessary to lessen or prevent a threat to life, health or safety of an individual or to public health or safety or for certain action to be undertaken by an enforcement body (e.g. prevention, detection, investigation, prosecution or punishment of criminal offences), or where such disclosure is authorised or required by law (including applicable privacy / data protection laws).
<br><br>

3.2. On NuvertOS, you may choose to use certain features that can be accessed through, or for which we partner with, other entities that are not otherwise affiliated with us. These features, which include social networking and geo-location tools, are operated by third parties, including social networks, and are clearly identified as such. These third parties may use or share personal information in accordance with their own privacy policies.
<br><br>

4. CONTROL ON PERSONAL INFORMATION
<br><br>


4.1. NuvertOS endeavours an enriched, hassle-free and smooth experience to you by allowing you to control certain personal information you do not wish to share or continue to share with us including but not limited to promotional offers, discounts, advertisements and similar communication provided by us to you, from time to time.
<br><br>

4.2. We expressly allow you to make changes and update your profile information in the “Your Account” section of the NuvertOS Platform. Further, during the course of the access to NuvertOS you may also control access to your device information or opt out of push notifications through your “Settings” app on your devices.
<br><br>

4.3. Where you wish to stop receiving promotional email communications, you can do so by clicking on the “unsubscribe link” provided in such communications. However, you may not opt out of service-related communications.
<br><br>

5. SECURITY & STORAGE OF USER INFORMATION
<br><br>

5.1. NuvertOS expressly undertakes not to sell, trade or disclose to third parties any information derived from the registration of, or use of, any online service (including names and addresses) without the consent of the user or Client (Except in case of search warrant, or other legal process or in the case of imminent physical harm to the user or others).Further, it is our responsibility to provide that any personal identifiable information we collect about you is stored in limited access cloud-based servers.
<br><br>

5.2. We expressly undertake to provide you with adequate safeguards to protect the security of these servers and your personally identifiable information. In the age of global internet and its outreach, using the Internet to collect and process personal data necessarily involves the transmission of data on a global basis. Therefore, by clicking our site and communicating electronically with us you acknowledge and agree to our processing of personal data in this way.
<br><br>

5.3. We process your personal data for legitimate interests on legal basis, except in specific circumstances where you provide consent or where the processing is necessary for a contract that you have with us or where you have asked us to take specific steps prior to entering into a contract. We place Google AdWords, display advertisements and use Google conversion tracking such as but not limited to other software of promotional activities for the purposes of personalized online ads based on interests and location.
<br><br>

5.4. We have taken extensive technical and operational security precautions to protect your data from being accidentally or intentionally manipulated, lost, destroyed, or accessed by unauthorized persons. Our security measures are reviewed regularly and updated in keeping with technological advances.
<br><br>

5.5. We retain your personal data for as long as it is required for you to use our Services, to provide our Services to you and to comply with laws. We will anonymise and/or aggregate your data if we intend to use it for analytical statistical purposes over longer periods.
<br><br>

5.6. We take appropriate steps to protect the information you share with us. We have implemented technology and security features and strict policy guidelines to safeguard the privacy of your personally identifiable information from unauthorized access and improper use or disclosure.
<br><br>

6. SOCIAL MEDIA INTEGRATIONS
<br><br>

6.1. Our websites and mobile applications may use social media features and widgets (such as “Like” and “Share” buttons/widgets). These are provided and operated by third party companies (i.e. Facebook, Twitter etc.) and are either hosted by a third party or hosted directly on our website or mobile application. Such features may collect information such as the page you are visiting on our website/mobile application, your IP address, and may set cookies to enable the feature to function properly.
<br><br>

6.2. If you are logged into your account with a third party link, then the third party may be able to link information about your visit to and use of our website to your social media account with them. Similarly, your interactions with the social media features may be recorded by the third party. In addition, such third party may send us information in line with their policies, such as your name, profile picture, gender, friend lists and any other information you have chosen to make available, and we may share information with the third party company for the purposes of serving targeted marketing to you via the third party social media platform. You can manage the sharing of information and opt out from targeted marketing via your privacy settings for the third party social media platform.
<br><br>

6.3. Your interactions with these social media features and widgets are governed by the privacy policy of the third party company providing them.
<br><br>


7. CHILDREN’S PERSONAL INFORMATION
<br><br>

We expressly provide that neither the NuvertOS site nor its Services are directed or intended towards knowingly, collecting or soliciting personal information from such users who are under the age of 18 years. We further provide to make our earnest efforts not to grant access to any user below the age of 18 years and where we have inadvertently collected personal information from a child under age 18, we will delete that information as quickly as possible.
<br><br>

8. WEBSITE CHANGES & MODIFICATIONS
<br><br>

We may change this Privacy Policy from time to time. We will post any changes here, so as a user be sure to check back periodically. However, please be assured that if the Privacy Policy changes in the future, we will not use the personal information you have submitted to us under this Privacy Policy in a manner that is materially inconsistent with this Privacy Policy, without your prior consent. If our privacy policy changes in the future, it will be posted here and a new effective date will be shown. You should access our privacy policy regularly to ensure you understand our current policies.
<br><br>

9. LINKS
<br><br>

For your convenience, our website provides links to other sites. When you click on one of their links, you are leaving our website and entering another site. We are not responsible for such third-party sites. You should carefully review the privacy statements of any other sites you visit because those privacy statements will apply to your visit to such other sites.
<br><br>

10. DISPUTE RESOLUTION AND JURISDICTION
<br><br>

It is expressly consented by the parties that in case of any dispute in relation to the contents of the privacy policy arises, the dispute will be resolved through ‘Mediation’ or ‘Arbitration’
<br><br>

a) Mediation: If a dispute between the parties arises, Parties will try to resolve the same amicably within themselves, giving mutual satisfaction to the parties. But if the parties are not able to reach such an amicable solution within fifteen (15) days from the date of one Party notifying the other regarding the cause of a dispute, the dispute will be resolved by arbitration, as described below.
<br><br>

b) Arbitration: In case of such failure, the dispute shall be referred to a sole arbitrator, who shall be mutually appointed by the Parties. In the event the Parties are unable to mutually agree on the identity of the sole arbitrator in the manner specified above, then the arbitration proceedings shall be conducted by the three Arbitrators of which the first arbitrator shall be appointed by Company, the second arbitrator by the User/Client and both such arbitrators appointed shall mutually appoint the third presiding arbitrator. The Arbitration proceedings shall be governed by the (Indian) Arbitration and Conciliation Act, 1996 and shall be held in New Delhi, India and the language of arbitration shall be English.
<br><br>

The Terms, Policy and any other agreements between the Parties are guarded by the laws, rules and regulations of India and this is consented by the Parties. The Courts at Delhi, India shall have exclusive jurisdiction over any disputes arising between the Parties.
<br><br>

11. CONTACT US
<br><br>

If you want to exercise any of the rights described above or are dissatisfied with the way we have used your information, you should contact us-
<br><br>
                </p>
            </div>

            <div class="col-12 main-container">
                <h3 class="text-center">NuvertOS Disclaimer Policy</h3>
                <div style="display: grid;">
                    <div class="divider"></div>
                </div>

                <p>
                    1.1. The information contained in this website or App is for general information purposes only. The information is provided to you by M/s TIMESTREAM TECHNOLOGIES PRIVATE LIMITED (hereinafter referred to as “NuvertOS”, “we” or us) and while we strive to make our reasonable efforts towards the user of information(hereinafter referred to as “us”) to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the site or the information, products, services, or the content contained on NuvertOS site (or on mobile application) for any purpose. Any choice made by you relying on such information is therefore strictly at your own risk.
                    <br><br>
1.2. We expressly hereby undertake that our role shall be limited as service provider for the limited purpose of facilitating cloud-based software services to streamline and digitalize the healthcare process of the users. Therefore, we do not exercise any control over the manner of performance and operation of the daily operation of the Client/Users/Pharmacy/other healthcare entity
<br><br>

1.3. In no event will NuvertOS be liable for any damages, including, without limitation, direct, indirect, incidental, special, consequential or punitive damages arising out of the use of or inability to use NuvertOS Platform. You hereby acknowledge and agree that the provisions of this section shall apply to all content on NuvertOS.
<br><br>

1.4. In addition to the terms set forth above, neither NuvertOS nor its affiliates, information providers or content partners shall be liable regardless of the cause or duration, for any errors, inaccuracies, omissions, or other defects in, or untimeliness or unauthenticity of, the information contained within NuvertOS, or for any delay or interruption in the transmission thereof to the user, or for any claims or losses arising there from or occasioned thereby. None of the foregoing parties shall be liable for any third-party claims or losses of any nature, including, but not limited to, lost profits, punitive or consequential damages.
<br><br>

1.5. Neither NuvertOS nor its affiliates, information providers or content providers warrant or guarantee the timeliness, sequence, accuracy or completeness of this information. Additionally, there are no warranties as to the results obtained from the use of the information.
<br><br>

1.6. Through NuvertOS (or clicking into our site or mobile application), you are able to link to other third party websites which are neither associated nor under the control of NuvertOS, as we have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorsement of any products/services or opinions expressed within them.
<br><br>
1.7. NuvertOS strives to makes reasonable efforts to ensure proper and smooth functioning of the Platform site thereby assuring a rich customer experience. However, we disagree to hold any responsibility or liability for being temporarily unavailable due to technical issues beyond our control.
                </p>
            </div>
        </div>
    </div>
</div>

<app-contact-card></app-contact-card>
